module.exports = __webpack_public_path__ + "img/Group1.53025ee4.png";